/* legend-blog.js — blog interactions.
   Article page: builds a table of contents from the H2/H3 headings (hover to preview,
   click to smooth-scroll to the heading) and injects up to 2 inline "see also"
   cross-link cards. Standard nav — no scroll-position tracking. Guarded by element
   presence, so it's a no-op on pages that don't use these. */
(function () {
  'use strict';

  function initArticle() {
    var body = document.querySelector('.legend-blog .article-body');
    if (!body) return;

    // Drop empty paragraphs Shopify's rich-text editor leaves between blocks
    // (<p></p>, <p> </p>, <p>&nbsp;</p> — trim() treats U+00A0 as whitespace).
    Array.prototype.forEach.call(body.querySelectorAll('p'), function (p) {
      if (!p.querySelector('img, iframe, embed, video, picture') && p.textContent.trim() === '') {
        p.style.display = 'none';
      }
    });

    // Table of contents from H2/H3 — hover to preview, click to smooth-scroll.
    var tocEl = document.getElementById('article-toc');
    var headings = body.querySelectorAll('h2, h3');
    if (tocEl && headings.length) {
      var ul = document.createElement('ul');
      ul.className = 'article-toc-list';
      Array.prototype.forEach.call(headings, function (h, i) {
        if (!h.id) {
          var slug = (h.textContent || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40);
          h.id = 'sec-' + i + (slug ? '-' + slug : '');
        }
        var li = document.createElement('li');
        li.className = 'toc-' + h.tagName.toLowerCase();
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        a.addEventListener('click', function (e) {
          e.preventDefault();
          // Persist the clicked entry's highlight (no scroll tracking — purely on click)
          var cur = tocEl.querySelector('a.active');
          if (cur) cur.classList.remove('active');
          a.classList.add('active');
          h.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (window.history && history.replaceState) history.replaceState(null, '', '#' + h.id);
        });
        li.appendChild(a);
        ul.appendChild(li);
      });
      tocEl.appendChild(ul);
    } else {
      var wrap = document.querySelector('.legend-blog .article-toc-wrap');
      if (wrap) wrap.style.display = 'none';
    }

    // Inline "see also" cards (max 2), inserted after ~600/1300-word anchors.
    var dataEl = document.getElementById('see-also-data');
    if (dataEl) {
      var items = [];
      try { items = JSON.parse(dataEl.textContent) || []; } catch (e) { items = []; }
      if (items.length) {
        var paras = Array.prototype.filter.call(body.children, function (el) { return el.tagName === 'P'; });
        var words = 0, inserted = 0, threshold = 600;
        for (var i = 0; i < paras.length && inserted < items.length && inserted < 2; i++) {
          words += (paras[i].textContent || '').split(/\s+/).length;
          if (words >= threshold) {
            paras[i].insertAdjacentElement('afterend', buildSeeAlso(items[inserted]));
            inserted++;
            threshold += 700;
          }
        }
      }
    }
  }

  function buildSeeAlso(it) {
    var a = document.createElement('a');
    a.href = it.url;
    a.className = 'article-seealso';
    var img = it.image
      ? '<img src="' + it.image + '" alt="" loading="lazy">'
      : '<div class="ph"></div>';
    a.innerHTML =
      '<div class="article-seealso-img">' + img + '</div>' +
      '<div class="article-seealso-body">' +
        '<div class="article-seealso-label">See also</div>' +
        '<div class="article-seealso-title">' + esc(it.title) + '</div>' +
        '<div class="article-seealso-cat">' + esc(it.category || '') + '</div>' +
      '</div>' +
      '<span class="article-seealso-arrow">&rarr;</span>';
    return a;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Search results page: renders the FULL native result set (embedded as JSON, capped
     at 250) client-side, with category/type/level/use filter chips that narrow the WHOLE
     set, a client-side "Show more", and chip state in f_* URL params. No-op unless the
     search grid + data blob are present. */
  var GROUPS = [
    { ns: 'cat', param: 'f_cat', label: 'Category' },
    { ns: 'type', param: 'f_type', label: 'Type' },
    { ns: 'level', param: 'f_level', label: 'Level' },
    { ns: 'use', param: 'f_use', label: 'Use' }
  ];
  var BATCH = 12;

  function humanize(v) {
    v = String(v || '').replace(/-/g, ' ');
    return v.charAt(0).toUpperCase() + v.slice(1);
  }

  function searchCardHtml(a) {
    var meta = esc((a.date || '') + ' · ' + a.mins + ' min');
    var eyebrow = '<span class="eyebrow">' + esc(a.eyebrow || 'Article') + '</span>';
    var title = '<h3>' + esc(a.title) + '</h3>';
    var inner;
    if (a.img) {
      inner = '<a href="' + esc(a.url) + '" class="latest-card">' +
        '<div class="latest-card-img"><img src="' + esc(a.img) + '" alt="" loading="lazy"></div>' +
        eyebrow + title + '<div class="start-card-meta">' + meta + '</div></a>';
    } else {
      inner = '<a href="' + esc(a.url) + '" class="latest-card latest-card--text">' +
        '<div class="latest-card-text">' + eyebrow + title + '</div>' +
        '<div class="start-card-meta">' + meta + '</div></a>';
    }
    return '<div class="search-card-wrap">' + inner + '</div>';
  }

  function initSearch() {
    var grid = document.getElementById('blog-search-grid');
    var dataEl = document.getElementById('blog-search-data');
    if (!grid || !dataEl) return;
    var data = [];
    try { data = JSON.parse(dataEl.textContent) || []; } catch (e) { data = []; }
    if (!data.length) return;

    var chipsEl = document.getElementById('blog-search-chips');
    var nomatch = document.getElementById('blog-search-nomatch');
    var moreBtn = document.getElementById('blog-search-more');
    var shown = BATCH;

    // Distinct values + counts per group, from the FULL result set.
    var values = {};
    GROUPS.forEach(function (g) { values[g.ns] = {}; });
    data.forEach(function (a) {
      (a.tags || []).forEach(function (t) {
        var i = t.indexOf(':');
        if (i < 0) return;
        var ns = t.slice(0, i), val = t.slice(i + 1);
        if (values[ns] && val) values[ns][val] = (values[ns][val] || 0) + 1;
      });
    });

    // Active state from URL.
    var params = new URLSearchParams(location.search);
    var active = {};
    GROUPS.forEach(function (g) {
      active[g.ns] = {};
      (params.get(g.param) || '').split(',').filter(Boolean).forEach(function (v) { active[g.ns][v] = true; });
    });
    function activeCount(ns) { return Object.keys(active[ns]).length; }
    function anyActive() { return GROUPS.some(function (g) { return activeCount(g.ns) > 0; }); }

    function filtered() {
      return data.filter(function (a) {
        return GROUPS.every(function (g) {
          if (!activeCount(g.ns)) return true;
          return (a.tags || []).some(function (t) {
            var i = t.indexOf(':');
            return i >= 0 && t.slice(0, i) === g.ns && active[g.ns][t.slice(i + 1)];
          });
        });
      });
    }

    function render() {
      var list = filtered();
      grid.innerHTML = list.slice(0, shown).map(searchCardHtml).join('');
      if (moreBtn) moreBtn.hidden = list.length <= shown;
      if (nomatch) nomatch.hidden = !(anyActive() && list.length === 0);
    }

    function syncUrl() {
      if (!(window.history && history.replaceState)) return;
      var p = new URLSearchParams(location.search);
      GROUPS.forEach(function (g) {
        var arr = Object.keys(active[g.ns]);
        if (arr.length) p.set(g.param, arr.join(',')); else p.delete(g.param);
      });
      history.replaceState(null, '', location.pathname + '?' + p.toString());
    }

    // Build chip UI.
    var built = [];
    GROUPS.forEach(function (g) {
      var vals = Object.keys(values[g.ns]).sort();
      if (!vals.length) return;
      var group = document.createElement('div');
      group.className = 'search-chip-group';
      group.innerHTML = '<span class="search-chip-label">' + g.label + '</span>';
      var chipWrap = document.createElement('div');
      chipWrap.className = 'search-chip-row-chips';
      vals.forEach(function (val) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'search-chip';
        btn.textContent = humanize(val) + ' (' + values[g.ns][val] + ')';
        if (active[g.ns][val]) btn.classList.add('is-active');
        btn.addEventListener('click', function () {
          if (active[g.ns][val]) delete active[g.ns][val]; else active[g.ns][val] = true;
          btn.classList.toggle('is-active');
          shown = BATCH; syncUrl(); render();
        });
        chipWrap.appendChild(btn); built.push(btn);
      });
      group.appendChild(chipWrap);
      chipsEl.appendChild(group);
    });
    if (built.length) chipsEl.hidden = false;

    var clearBtn = document.getElementById('blog-search-clear');
    if (clearBtn) clearBtn.addEventListener('click', function () {
      GROUPS.forEach(function (g) { active[g.ns] = {}; });
      built.forEach(function (b) { b.classList.remove('is-active'); });
      shown = BATCH; syncUrl(); render();
    });

    if (moreBtn) moreBtn.addEventListener('click', function () { shown += BATCH; render(); });

    render();
  }

  function start() { initArticle(); initSearch(); }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
